// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4a-1";
export var standaloneTable = "_4a-0";